import appApi from '../../../../../../api/app-api';
import globalUserPage from '../../../../../../stores/global-user-page';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';
import { UserSummaryType } from '../../../../../../api/types/user/user-summary.type';

export const updateInstallmentBranchOperation = async (
  user: UserSummaryType,
  installmentPlanId: number,
  branchId: number,
  setLoading: (loading: boolean) => void,
  onSuccess?: () => void,
): Promise<boolean> => {
  try {
    setLoading(true);

    const res = await appApi.updateInstallmentPlanBranch(
      user.id,
      installmentPlanId,
      branchId,
    );

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return false;
    }

    // Refresh user details so the updated branchId is reflected on every
    // installment plan card (same pattern used by the credit-card switch flow).
    const updatedUserDetails = await appApi.getUserStudentDetails(user.id);
    globalUserPage.studentDetails = updatedUserDetails.data.body;

    toast.success('שלוחת הוראת הקבע עודכנה בהצלחה');
    setLoading(false);
    onSuccess?.();
    return true;
  } catch (e) {
    console.error('Error updating installment branch:', e);
    toast.error('שגיאה בעדכון שלוחת הוראת הקבע');
    setLoading(false);
    return false;
  }
};
